module.exports = __webpack_public_path__ + "static/media/TN-Men-Shirts.b4a411c9.svg";